/* PELUX · Pays et langue du visiteur appliqués d'office (décision d'Ilyes du 2026-10-17 : « que
   l'adresse prime », sans bandeau — chaque clic en plus éloigne de l'achat).
   Données : snippets/pelux-localisation-auto.liquid, rendu dans le <head> par layout/theme.liquid (seulement
   quand plus d'un pays ou d'une langue est publié), juste avant ce script, chargé en async : il part sans
   attendre la fin de la page (600 Ko de HTML sur une fiche produit). Rien de visible.

   À la PREMIÈRE visite d'un site (repère local `pelux-pays-auto`), on demande à Shopify le pays du
   visiteur (adresse IP : /browsing_context_suggestions.json) et on bascule d'office vers ce pays —
   ses prix, sa monnaie, son site (pelux.fr pour la France, peluxcat.com pour les 36 autres) :
   - la langue est celle de son téléphone ou de son ordinateur si la boutique la parle (un Suisse
     peut parler allemand ou français), sinon celle de son pays (français pour la France et le
     Luxembourg), sinon l'anglais ;
   - la bascule est UN seul saut : les balises hreflang de la page donnent son adresse exacte dans ce pays
     et cette langue (domaine, /fr, nom traduit), et `?country=XX` y fixe le pays et la monnaie dès la
     première réponse. Le formulaire de Shopify, qui fait jusqu'à trois allers-retours (mesuré le 17/10 :
     1,3 à 2,5 s de mauvaise page à l'écran), ne sert plus que de repli, pour une page sans hreflang
     (404, connexion) ;
   - il change ensuite de langue d'un geste au bouton « FR + drapeau » de l'en-tête
     (snippets/pelux-langue-compacte.liquid), et de pays au sélecteur de pays.

   Garde-fous :
   - une seule fois par site : jamais par-dessus un choix du visiteur ;
   - après une bascule, l'adresse d'arrivée porte `pelux_auto=1` : le site d'arrivée (même sur l'autre
     domaine, qui ne partage pas ce repère) pose le sien sans rien rebasculer — aucun aller-retour
     possible — et efface la marque, et le `country` ajouté, de la barre d'adresse ;
   - TOUT formulaire de pays ou de langue de la page emporte cette marque : un choix fait à la main
     (un Français en vacances en Espagne qui revient à « France ») n'est jamais défait par le site
     d'arrivée ;
   - robots (moteurs, aperçus de liens, mesures de vitesse) : rien — un robot qui verrait une page d'un
     site renvoyer vers l'autre la prendrait pour une redirection ; pays fermé (États-Unis,
     Royaume-Uni…) : rien non plus ;
   - sans stockage local (navigation privée stricte) : rien d'automatique, aucune boucle possible. */
(function () {
  'use strict';

  var CLE = 'pelux-pays-auto';
  var MARQUE = 'pelux_auto';
  var LANGUE_DU_PAYS = { FR: 'fr', LU: 'fr', MC: 'fr' };
  var ROBOTS = /bot[\/\-;]|crawl|spider|slurp|mediapartners|apis-google|google-inspectiontool|feedfetcher|bingpreview|facebookexternalhit|lighthouse|headlesschrome|pagespeed|gtmetrix|ptst/i;

  // undefined = stockage indisponible ; null = rien d'enregistré.
  function lire(cle) {
    try { return window.localStorage.getItem(cle); } catch (e) { return undefined; }
  }
  function ecrire(cle, valeur) {
    try { window.localStorage.setItem(cle, valeur); return true; } catch (e) { return false; }
  }

  var noeud = document.getElementById('PeluxLocalisationAuto');
  if (!noeud || (window.Shopify && window.Shopify.designMode)) return;   // éditeur de thème
  var donnees;
  try { donnees = JSON.parse(noeud.textContent); } catch (e) { return; }
  var ICI = donnees.ici || {};
  var PAYS = String(ICI.pays || '').toUpperCase();
  var LANGUE = String(ICI.langue || '').toLowerCase();

  // Chaque formulaire de pays ou de langue (en-tête, menu ☰, pied de page) revient avec la marque : la page
  // d'arrivée sait qu'un choix vient d'être fait et n'y touche pas.
  function marquerFormulaires() {
    var champs = document.querySelectorAll('form[action$="/localization"] input[name="return_to"]');
    for (var i = 0; i < champs.length; i++) {
      try {
        var u = new URL(champs[i].value || window.location.pathname, window.location.origin);
        u.searchParams.set(MARQUE, '1');
        champs[i].value = u.pathname + u.search;
      } catch (e) {}
    }
  }

  // Arrivée après une bascule : repère posé, marque (et pays ajouté) effacés de l'adresse, rien d'autre.
  function arrivee() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has(MARQUE)) return false;
    ecrire(CLE, 'arrivee:' + PAYS + '-' + LANGUE);
    params.delete(MARQUE);
    params.delete('country');
    var reste = params.toString();
    try {
      window.history.replaceState(window.history.state, '',
        window.location.pathname + (reste ? '?' + reste : '') + window.location.hash);
    } catch (e) {}
    return true;
  }

  function interroger() {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(racine + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',
      { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (rep) { if (rep) decider(rep); })
      .catch(function () {});
  }

  // Langues parlées pour un AUTRE pays : celles de ce site, plus celles que les balises hreflang de la
  // page annoncent (l'autre domaine peut en parler d'autres que celui-ci).
  function languesConnues() {
    var dispo = (donnees.langues || []).slice();
    var liens = document.querySelectorAll('link[rel="alternate"][hreflang]');
    for (var i = 0; i < liens.length; i++) {
      var l = (liens[i].getAttribute('hreflang') || '').toLowerCase().split('-')[0];
      if (l && l !== 'x' && dispo.indexOf(l) === -1) dispo.push(l);
    }
    return dispo;
  }

  function choisirLangue(pays) {
    // Même pays = même site : seules ses langues comptent (pas de rechargement pour une langue absente).
    var dispo = pays === PAYS ? (donnees.langues || []) : languesConnues();
    var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var i = 0; i < prefs.length; i++) {
      var l = String(prefs[i] || '').toLowerCase().split('-')[0];
      if (l && dispo.indexOf(l) !== -1) return l;
    }
    var parDefaut = LANGUE_DU_PAYS[pays] || 'en';
    return dispo.indexOf(parDefaut) !== -1 ? parDefaut : LANGUE;
  }

  function decider(rep) {
    var d = rep.detected_values && rep.detected_values.country;
    var pays = d && String(d.handle || '').toUpperCase();
    if (!pays) return;                                                    // rien de détecté : page suivante
    if ((donnees.pays || []).indexOf(pays) === -1) {
      ecrire(CLE, 'ferme:' + pays);                                       // pays fermé : on ne touche à rien
      return;
    }
    var langue = choisirLangue(pays);
    if (pays === PAYS && langue === LANGUE) {
      ecrire(CLE, 'rien:' + pays + '-' + langue);                         // déjà le bon pays, la bonne langue
      return;
    }
    if (!ecrire(CLE, 'auto:' + pays + '-' + langue)) return;              // sans repère écrit, pas de bascule
    basculer(pays, langue);
  }

  // Adresse de CETTE page dans ce pays et cette langue, d'après les hreflang : « fr-ch » d'abord ; pour un
  // pays qu'aucune balise ne cite (la France : pelux.fr porte les balises sans région), « fr » seul.
  function adresse(pays, langue) {
    var liens = document.querySelectorAll('link[rel="alternate"][hreflang]');
    var voulue = langue + '-' + pays.toLowerCase();
    var exacte = null, sansRegion = null, cite = false;
    for (var i = 0; i < liens.length; i++) {
      var h = (liens[i].getAttribute('hreflang') || '').toLowerCase();
      if ((h.split('-')[1] || '') === pays.toLowerCase()) cite = true;
      if (h === voulue) exacte = liens[i].href;
      else if (h === langue) sansRegion = liens[i].href;
    }
    return exacte || (cite ? null : sansRegion);
  }

  function basculer(pays, langue) {
    // La page telle qu'elle est (coloris choisi, suivi des publicités compris), marquée pour le site d'arrivée.
    var params = new URLSearchParams(window.location.search);
    params.delete('country');
    params.set(MARQUE, '1');
    var cible = adresse(pays, langue);
    if (cible) {
      try {
        var u = new URL(cible, window.location.href);
        params.forEach(function (valeur, nom) { u.searchParams.append(nom, valeur); });
        u.searchParams.set('country', pays);
        u.hash = window.location.hash;
        window.location.replace(u.toString());                            // « retour » ramène d'où il venait
        return;
      } catch (e) {}
    }
    soumettre(pays, langue, params);
  }

  // Repli : le formulaire de pays et de langue de Shopify, construit ici (la page peut être encore en cours
  // de chargement).
  function soumettre(pays, langue, params) {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var champs = {
      form_type: 'localization', utf8: '✓', _method: 'put',
      return_to: window.location.pathname + '?' + params.toString(),
      country_code: pays, language_code: langue
    };
    var form = document.createElement('form');
    form.method = 'post';
    form.action = racine + 'localization';
    form.acceptCharset = 'UTF-8';
    form.enctype = 'multipart/form-data';
    form.hidden = true;
    Object.keys(champs).forEach(function (nom) {
      var champ = document.createElement('input');
      champ.type = 'hidden';
      champ.name = nom;
      champ.value = champs[nom];
      form.appendChild(champ);
    });
    (document.body || document.documentElement).appendChild(form);
    form.submit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marquerFormulaires);
  else marquerFormulaires();
  if (arrivee()) return;
  if (ROBOTS.test(navigator.userAgent || '')) return;
  if (lire(CLE) !== null) return;                                         // déjà décidé ici, ou pas de stockage
  interroger();
})();
